import sc from 'web/components/styled';
import table from './table.css';

const Table = sc.table(table);
Table.displayName = 'Table';

export default Table;
